import { apiGet, apiPost, apiDelete } from './api';
import { Character } from '../types/character';

export async function getUserCharacters(): Promise<Character[]> {
  return apiGet<Character[]>('/api/characters');
}

export async function saveCharacter(character: Character): Promise<Character> {
  const result = await apiPost<{ character: Character }>('/api/characters', character);
  return result.character;
}

export async function deleteUserCharacter(characterId: string): Promise<void> {
  await apiDelete(`/api/characters/${characterId}`);
}

export async function getCharacterCount(): Promise<{ count: number; is_premium: number; limit: number | null }> {
  return apiGet('/api/characters/count');
}

export async function updateLocalCharacters(localCharacters: Character[]): Promise<Character[]> {
  try {
    const serverCharacters = await getUserCharacters();
    const merged = new Map<string, Character>();

    [...localCharacters, ...serverCharacters].forEach(char => {
      const existing = merged.get(char.id);
      if (!existing || (char.lastModified || 0) > (existing.lastModified || 0)) {
        merged.set(char.id, char);
      }
    });

    const mergedArray = Array.from(merged.values());

    // Sauvegarder les fiches locales non encore sur le serveur
    const serverIds = new Set(serverCharacters.map(c => c.id));
    for (const char of localCharacters) {
      if (!serverIds.has(char.id)) {
        try {
          await saveCharacter(char);
        } catch (err: unknown) {
          if ((err as { error?: string }).error === 'LIMIT_REACHED') break;
        }
      }
    }

    localStorage.setItem('character-creator-data', JSON.stringify(mergedArray));
    return mergedArray;
  } catch {
    return localCharacters;
  }
}
